import { Link } from 'react-router-dom';
import { articles, hotArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

const statusRows = [
  { key: 'reversed' as const, label: '已反转', bar: 'bg-primary-500' },
  { key: 'confirmed' as const, label: '已澄清', bar: 'bg-secondary-500' },
  { key: 'clarifying' as const, label: '澄清中', bar: 'bg-accent-500' },
];

export default function LatestSection() {
  const sorted = [...articles].sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1));
  const latest = sorted.filter((item) => item.id !== hotArticles[0]?.id).slice(0, 4);
  const total = articles.length;

  return (
    <section aria-labelledby="latest-heading" className="border-y border-background-300 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-8">
          <div className="reveal mb-7 flex flex-wrap items-end justify-between gap-3">
            <div>
              <span className="text-xs font-semibold font-label uppercase tracking-widest text-primary-600">
                Latest Updates
              </span>
              <h2 id="latest-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                最新反转与澄清
              </h2>
            </div>
            <Link
              to="/archive"
              className="flex items-center gap-1.5 text-sm font-medium font-label text-primary-700 transition-all hover:gap-2.5"
            >
              进入完整档案
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <div className="flex flex-col gap-6">
            {latest.map((item) => (
              <div key={item.id} className="reveal">
                <ArticleCard article={item} variant="horizontal" />
              </div>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="reveal rounded-lg border border-background-300 bg-background-50 p-5 md:p-6">
            <div className="flex items-center gap-2 border-b border-background-200 pb-4">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-fire-line" aria-hidden="true" />
              </span>
              <h2 className="font-heading text-lg font-bold text-foreground-950">热议榜</h2>
            </div>
            <div className="mt-5 flex flex-col gap-5">
              {hotArticles.slice(0, 5).map((item, index) => (
                <ArticleCard
                  key={item.id}
                  article={item}
                  variant="compact"
                  indexText={String(index + 1).padStart(2, '0')}
                />
              ))}
            </div>
          </div>

          <div className="reveal mt-6 rounded-lg border border-background-300 bg-background-50 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">当前案例构成</h2>
            <p className="mt-2 text-xs leading-relaxed text-foreground-500">
              共收录 {total} 条示例案例，按核实状态分布如下。
            </p>
            <div className="mt-5 flex flex-col gap-4">
              {statusRows.map((row) => {
                const count = articles.filter((item) => item.status === row.key).length;
                const percent = total ? Math.round((count / total) * 100) : 0;
                return (
                  <div key={row.key}>
                    <div className="mb-2 flex items-center justify-between text-xs font-label">
                      <span className="text-foreground-700">{row.label}</span>
                      <span className="text-foreground-500">
                        {count} 条 · {percent}%
                      </span>
                    </div>
                    <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div className={`h-full rounded-full ${row.bar}`} style={{ width: `${percent}%` }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}